import { useState, useRef, useCallback } from 'react';
import { ExpanderContext } from './ExpanderContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const ExpanderProvider = ({
  children
}) => {
  const isExpandableSectionMap = useRef(new Map()).current;
  const [isExpanded, setIsExpanded] = useState(false);
  const [hasExpandableSections, setHasExpandableSections] = useState(false);

  // we're keeping a map of sections and whether they are expandable
  // this is used to determine if the expand action button should be shown
  const updateExpandableSection = useCallback((sectionName, isExpandable) => {
    isExpandableSectionMap.set(sectionName, isExpandable);
    setHasExpandableSections(Array.from(isExpandableSectionMap.values()).some(value => value));
  }, [isExpandableSectionMap]);
  const getExpandableSection = useCallback(sectionName => {
    return isExpandableSectionMap.get(sectionName);
  }, [isExpandableSectionMap]);
  return /*#__PURE__*/_jsx(ExpanderContext.Provider, {
    value: {
      isExpanded,
      setIsExpanded,
      hasExpandableSections,
      isExpandableSectionMap,
      getExpandableSection,
      updateExpandableSection
    },
    children: children
  });
};